import base from '../dr-base'
import drTextArea from './dr-text-area.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-text-area',
  name: 'Text area',
  group: 'Input widgets',
  icon: 'line-height',
  ...base,
  properties: {
    ...base.properties,
    Caption: {
      name: 'vuetifyWidgets.dr-text-area.caption',
      type: 'string',
      default: ''
    },
    Required: {
      name: 'vuetifyWidgets.dr-text-field.required',
      type: 'boolean'
    },
    Text: {
      name: 'vuetifyWidgets.dr-text-area.text',
      type: 'string',
      default: '',
      component: 'dr-value-editor'
    },
    Style: {
      name: 'vuetifyWidgets.dr-text-area.style',
      type: 'string',
      default: 'regular',
      enum: [{
        value: 'regular',
        text: 'Regular'
      }, {
        value: 'solo',
        text: 'Solo'
      }, {
        value: 'filled',
        text: 'Filled'
      }, {
        value: 'outlined',
        text: 'Outlined'
      }]
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'Event onChange'
    }
  }
}

export default {
  schema,
  component: drTextArea,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}